module.exports = __webpack_public_path__ + "static/media/view0001.17c28c01.png";